import React from 'react'
import { Toaster as HotToaster } from 'react-hot-toast'

const Toaster = () => {
  return (
    <HotToaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: 'var(--color-white)',
          color: 'var(--color-neutral-900)',
          border: '1px solid var(--color-neutral-200)',
          borderRadius: '0.75rem',
          padding: '1rem',
          fontSize: '0.875rem',
          fontWeight: '500',
          boxShadow: 'var(--shadow-medium)',
        },
        success: {
          iconTheme: {
            primary: 'var(--color-primary-teal)',
            secondary: 'var(--color-white)',
          },
        },
        error: {
          iconTheme: {
            primary: 'var(--color-secondary-red)',
            secondary: 'var(--color-white)',
          },
        },
      }}
    />
  )
}

export { Toaster }
